import React, { useEffect, useState } from "react";
import { APIProvider } from '@vis.gl/react-google-maps';
import ClinicResults from './ClinicResults';

const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? 'AIzaSyDKR2D-xrjNTAS-Ug5cL78tV5uwTkcIK0w';

export default function ClinicAreas({
    areaID = ''
}) {
    const [clinicData, setClinicData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getClinicData = async () => {

        let url = '/cd/feeds/finder/clinics/area/' + areaID;

        fetch(url)
            .then(response => response.json())
            .then(data => {
                setClinicData(data);
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
            });

    };

    useEffect(() => {
        setLoading(true);
        getClinicData();
    }, []);

    return (
        <APIProvider apiKey={apiKey}>

            {clinicData && (
                <ClinicResults clinicData={clinicData} loading={loading} fitMarkers={true} />
            )}

        </APIProvider>

    );
};